module.exports = __webpack_public_path__ + "7793318f1cbb43063898953b44880c8e.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/metal.png
// module id = 610
// module chunks = 0